/* eslint-disable no-fallthrough */
import * as TYPES from './DrivingDirections.types';

const initialState = {
  directions: [],
  selectedDirection: {},
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_DRIVING_DIRECTIONS_LIST_SUCCESS: {
      return {
        ...state,
        directions: action?.result?.data,
      };
    }

    case TYPES.GET_DRIVING_DIRECTION_SUCCESS: {
      return {
        ...state,
        selectedDirection: action?.result?.data,
      };
    }

    default:
      return state;
  }
};

export default reducer;
